import { usd } from "./helpers";

interface FinancialSummaryProps {
  grossSales: number;
  grossCredit: number;
  grossRfid: number;
  grossCashBalance: number;
  salesTax: number;
  netSales: number;
  revenueShare: number;
  commissionAmount: number;
  vendorCommission: number;
  eventName: string;
}

export const FinancialSummary = ({
  grossSales,
  grossCredit,
  grossRfid,
  grossCashBalance,
  salesTax,
  netSales,
  revenueShare,
  commissionAmount,
  vendorCommission,
  eventName,
}: FinancialSummaryProps) => (
  <div className="space-y-1 text-sm">
    <SummaryRow label="Gross Sales" value={usd(grossSales)} bold />
    {grossCredit > 0 && <SummaryRow label="Credit Sales" value={usd(grossCredit)} indent />}
    {grossRfid > 0 && <SummaryRow label="RFID Sales" value={usd(grossRfid)} indent />}
    {grossCashBalance > 0 && <SummaryRow label="Cash Balance Sales" value={usd(grossCashBalance)} indent />}
    <SummaryRow label="Less Sales Tax" value={`(${usd(salesTax)})`} />
    <SummaryRow label="Vendor Net Sales" value={usd(netSales)} bold />
    <SummaryRow
      label={`${eventName || "Event"} Commission (${revenueShare}%)`}
      value={`(${usd(commissionAmount)})`}
    />
    <div className="border-t border-gray-300 pt-1 mt-1">
      <SummaryRow label="Vendor Commission" value={usd(vendorCommission)} bold />
    </div>
  </div>
);

const SummaryRow = ({
  label,
  value,
  bold,
  indent,
}: {
  label: string;
  value: string;
  bold?: boolean;
  indent?: boolean;
}) => (
  <div className="flex justify-between py-0.5">
    <span
      className={`${bold ? "font-semibold text-gray-900" : "text-gray-600"} ${indent ? "pl-4" : ""}`}
    >
      {label}
    </span>
    <span className={`tabular-nums ${bold ? "font-semibold text-gray-900" : "text-gray-700"}`}>
      {value}
    </span>
  </div>
);
